const ACTIVITIES_API = {
	ACTIVITIES: '/activities',
	ACTIVITY: (id: number) => `/activities/${id}`,
	ACTIVITY_TYPES: '/activity-types',
	// LMS activities available for course mapping (per external LMS instance).
	LMS_INSTANCE_ACTIVITIES: '/lms-instance-activities'
};

export default ACTIVITIES_API;
